import Vue from 'vue'
import { ToastPlugin, ModalPlugin } from 'bootstrap-vue'
import VueLodash from 'vue-lodash'
import lodash from 'lodash'
import moment from 'moment'
import momentDurationFormatSetup from 'moment-duration-format'
import VueSocketIOExt from 'vue-socket.io-extended'
import { io } from 'socket.io-client'
import millify from 'millify'
import i18n from '@/libs/i18n'
import jwtService from '@/auth/jwt/useJwt'

import router from './router'
import store from './store'
import App from './App.vue'

// Global Components
import './global-components'

// Import french language for moment
import 'moment/locale/fr'

// 3rd party plugins
import '@axios'
import '@/libs/loadScript'
import '@/libs/constants'
import '@/libs/acl'
import '@/libs/portal-vue'
import '@/libs/clipboard'
import '@/libs/toastification'
import '@/libs/sweet-alerts'
import '@/libs/vue-select'
import '@/libs/shortkey'
import '@/libs/posthog'

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)

// Lodash
Vue.use(VueLodash, { lodash })

// Moment
Vue.prototype.moment = moment
momentDurationFormatSetup(moment)

// Millify
Vue.prototype.millify = millify

// Inject store
Vue.prototype.store = store

// Inject router to allow redirection in jwtService
jwtService.routerInstance = router

// Socket.io
const socket = io(process.env.VUE_APP_SOCKET_URL, {
  autoConnect: false,
})
Vue.use(VueSocketIOExt, socket, {
  store,
  actionPrefix: 'SOCKET_', // keep prefix in uppercase
  eventToActionTransformer: actionName => lodash.toUpper(lodash.snakeCase(actionName)), // cancel camel case
})

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

require('@core/assets/fonts/feather/iconfont.css')

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')
